import s3Object from './s3getObject';

export function isBlobUrl(url: string): boolean {
    return url.startsWith('blob:');
}

export function isAbsoluteUrl(url: string): boolean {
    return /^https?:\/\//i.test(url) || url.startsWith('//');
}

export function isLocalUrl(url: string): boolean {
    const trimmed = url.trim();
    return (
        isBlobUrl(trimmed) ||
        trimmed.startsWith('data:') ||
        isAbsoluteUrl(trimmed) ||
        trimmed.startsWith('/')
    );
}

export function resolvePreviewUrl(
    url: string,
    options?: { extension?: string; videoAsset?: string },
): string {
    const trimmed = url.trim();
    if (!trimmed) {
        return '';
    }

    if (isLocalUrl(trimmed)) {
        return trimmed;
    }

    const extension = (options?.extension ?? '').toLowerCase();
    if (extension === 'mp4' && options?.videoAsset) {
        return options.videoAsset;
    }

    return s3Object(trimmed);
}
